import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {
  ChangePublicationsPageSizeAction,
  LoadPublicationsSuccessAction,
  OrderPublicationsByAction,
  PagePublicationsToAction,
  publicationListActionTypes,
  QuickSearchPublicationsAction, SearchPublicationsAction,
  ToggleSearchPublicationsAction
} from '../actions/publications-list';
import {DEFAULT_PAGE_SIZE} from '../../shared';
import {PublicationFilter} from '../models/publication-filter';
import { Publication } from '../../shared/models/publication';

export interface PublicationsState {
  array: Publication[];
  showFilter: boolean;
  quickSearch: string;
  filter: PublicationFilter;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
}

const initialState: PublicationsState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'created descending',
  count: 0,
};

export function PublicationsReducer(state: PublicationsState = initialState, action: Action): PublicationsState {
  switch (action.type) {
    case publicationListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case publicationListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case publicationListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case publicationListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case publicationListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case publicationListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case publicationListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case publicationListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case publicationListActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleToggleSearchAction(state: PublicationsState, action: ToggleSearchPublicationsAction): PublicationsState {
  const newState: PublicationsState = {
    ... state,
    showFilter: action.payload
  };
  return newState;
}

function handleQuickSearchAction(state: PublicationsState, action: QuickSearchPublicationsAction): PublicationsState {
  const newState: PublicationsState = {
    ... state,
    quickSearch: action.payload,
    page: 1
  };
  return newState;
}

function handleSearchAction(state: PublicationsState, action: SearchPublicationsAction): PublicationsState {
  const newState: PublicationsState = {
    ... state,
    filter: action.payload,
    page: 1
  };
  return newState;
}

function handlePageToAction(state: PublicationsState, action: PagePublicationsToAction): PublicationsState {
  const newState: PublicationsState = {
    ... state,
    page: action.payload
  };
  return newState;
}

function handleLoadSuccessAction(state: PublicationsState, action: LoadPublicationsSuccessAction): PublicationsState {
  const newState: PublicationsState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count
  };
  return newState;
}

function handleChangePageSizeAction(state: PublicationsState, action: ChangePublicationsPageSizeAction): PublicationsState {
  const newState: PublicationsState = {
    ... state,
    page: 1,
    pageSize: action.payload
  };
  return newState;
}
function handleOrderByAction(state: PublicationsState, action: OrderPublicationsByAction): PublicationsState {
  const newState: PublicationsState = {
    ... state,
    orderBy: action.payload
  };
  return newState;
}

function handleLoadClearActions(): PublicationsState {
  const newState: PublicationsState = {
    array: undefined,
    showFilter: false,
    quickSearch: undefined,
    filter: undefined,
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    orderBy: 'created descending',
    count: 0
  };
  return newState;
}

function handleLoadErrorActions(state: PublicationsState): PublicationsState {
  return state;
}

export const publicationsSelectors = {
  showFilter: (state: PublicationsState) => _.get(state, 'showFilter', false),
  quickSearch: (state: PublicationsState) => _.get(state, 'quickSearch'),
  filter: (state: PublicationsState) => _.get(state, 'filter'),
  page: (state: PublicationsState) => _.get(state, 'page', 1),
  pageSize: (state: PublicationsState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: PublicationsState) => _.get(state, 'orderBy'),
  array: (state: PublicationsState) => _.get(state, 'array', []),
  count: (state: PublicationsState) => _.get(state, 'count', 0)
};
